import { useTypedSelector } from '@Features/store';
import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';

const PublicOnlyRoute: React.FC<RouteProps> = ({ ...props }) => {
	const isAuth = useTypedSelector((state) => state.auth.isAuth);

	if (!isAuth) {
		return <Route {...props} />;
	} else {
		return <Redirect to="/dashboard" />;
	}
};

export default PublicOnlyRoute;
